import { isClerkAPIResponseError } from '@clerk/react/errors';

/** The first error Clerk reported, flattened to what the screens show. */
export interface ClerkErrorInfo {
  code: string;
  message: string;
  /** The request field the error is about (`identifier`, `password`, `code`, ...). */
  param?: string;
}

export function describeClerkError(error: unknown): ClerkErrorInfo {
  if (isClerkAPIResponseError(error)) {
    const first = error.errors[0];
    if (first) {
      const param = (first.meta as { paramName?: string } | undefined)?.paramName;
      return {
        code: first.code,
        message: first.longMessage ?? first.message,
        param,
      };
    }
  }
  if (error && typeof error === 'object' && 'code' in error && 'message' in error) {
    const { code, message, longMessage } = error as {
      code: string;
      message: string;
      longMessage?: string;
    };
    return { code, message: longMessage ?? message };
  }
  return { code: 'unknown', message: 'Something went wrong. Try again.' };
}
